/**
 * Strings of the shared components (`ui.*`), in every locale: both apps use them.
 */
const uiNl = {
    'ui.close': 'Sluiten',
    'ui.cancel': 'Annuleren',
    'ui.confirm': 'Bevestigen',
    'ui.search': 'Zoeken…',
    'ui.noResults': 'Geen resultaten',
    'ui.loadFailed': 'Laden is mislukt',
    'ui.somethingWrong': 'Er ging iets mis',
    'ui.retry': 'Opnieuw proberen',
};
const uiFr = {
    'ui.close': 'Fermer',
    'ui.cancel': 'Annuler',
    'ui.confirm': 'Confirmer',
    'ui.search': 'Rechercher…',
    'ui.noResults': 'Aucun résultat',
    'ui.loadFailed': 'Chargement impossible',
    'ui.somethingWrong': 'Une erreur s’est produite',
    'ui.retry': 'Réessayer',
};
const uiEn = {
    'ui.close': 'Close',
    'ui.cancel': 'Cancel',
    'ui.confirm': 'Confirm',
    'ui.search': 'Search…',
    'ui.noResults': 'No results',
    'ui.loadFailed': 'Could not load',
    'ui.somethingWrong': 'Something went wrong',
    'ui.retry': 'Try again',
};
/**
 * Everything a partner user reads: the portal and the emails it gets. French is the reference;
 * every key exists in French and Dutch (the type enforces it). French uses "vous", Dutch "je".
 * `{name}` placeholders are filled by `t()`; callers escape values where HTML is produced.
 */
const portalFr = {
    'portal.brand': 'Wally Partenaires',
    'portal.language': 'Langue',
    'portal.signOut': 'Se déconnecter',
    'portal.login.title': 'Connexion au portail partenaire',
    'portal.login.body': 'Saisissez votre adresse e-mail professionnelle. Nous vous envoyons un lien de connexion.',
    'portal.login.email': 'Adresse e-mail',
    'portal.login.submit': 'Recevoir un lien de connexion',
    'portal.login.sent.title': 'Vérifiez votre boîte de réception',
    'portal.login.sent.body': 'Si {email} a accès au portail, vous recevrez un lien de connexion dans quelques instants. Le lien est valable 15 minutes.',
    'portal.login.again': 'Utiliser une autre adresse',
    'portal.verify.title': 'Se connecter',
    'portal.verify.body': 'Cliquez sur le bouton pour vous connecter au portail partenaire.',
    'portal.verify.submit': 'Se connecter',
    'portal.verify.invalid': 'Ce lien n’est plus valable. Il a peut-être déjà été utilisé ou a expiré. Demandez-en un nouveau.',
    'portal.nav.dashboard': 'Tableau de bord',
    'portal.nav.leads': 'Leads',
    'portal.nav.register': 'Inscrire un lead',
    'portal.nav.statements': 'Décomptes',
    'portal.dashboard.welcome': 'Bonjour {name}',
    'portal.dashboard.intro': 'Suivez ici les leads que vous avez inscrits, leur statut et vos commissions.',
    'portal.dashboard.total': '{count} leads inscrits',
    'portal.dashboard.register': 'Inscrire un nouveau lead',
    'portal.leads.title': 'Vos leads',
    'portal.leads.empty': 'Vous n’avez encore inscrit aucun lead.',
    'portal.leads.col.name': 'Lead',
    'portal.leads.col.number': 'N° d’entreprise',
    'portal.leads.col.status': 'Statut',
    'portal.leads.col.submitted': 'Inscrit le',
    'portal.leads.col.signed': 'Contrat signé le',
    'portal.register.title': 'Inscrire un lead',
    'portal.register.rules': 'Un lead est l’un de vos clients existants : un cabinet avec lequel vous entretenez déjà une relation client effective. Les simples prospects ne peuvent pas être inscrits. Wally vérifie chaque inscription ; la première inscription valable d’un numéro d’entreprise est prioritaire.',
    'portal.register.submit': 'Inscrire',
    'portal.register.duplicate': 'Vous avez déjà inscrit ce client.',
    'portal.register.entityChanged': 'L’entité a changé dans un autre onglet. Vérifiez l’entité choisie et inscrivez à nouveau.',
    'portal.field.legalName': 'Dénomination légale exacte',
    'portal.field.country': 'Pays',
    'portal.field.companyNumber': 'Numéro d’entreprise',
    'portal.field.companyNumber.invalid': 'Ce numéro n’est pas valable.',
    'portal.field.vatNumber.optional': 'Numéro de TVA (facultatif)',
    'portal.field.rcs': 'Numéro RCS (facultatif)',
    'portal.field.rcs.hint': 'Par exemple : B123456',
    'portal.field.rcs.invalid': 'Ce numéro RCS n’est pas valable (une lettre puis des chiffres, par exemple B123456).',
    'portal.field.entity': 'Pour quelle entité ?',
    'portal.field.entity.hint': 'L’entité qui reçoit la commission sur ce client.',
    'portal.field.entity.required': 'Choisissez l’entité.',
    'portal.entity.switch': 'Changer d’entité',
    'portal.field.since': 'Client depuis',
    'portal.field.since.hint': 'Par exemple : 2019',
    'portal.field.description': 'Votre relation avec ce client',
    'portal.field.description.hint': 'Ce que vous lui fournissez (logiciels, services), pour que Wally puisse vérifier la relation.',
    'portal.field.contact': 'Personne de contact au cabinet (facultatif)',
    'portal.field.contactName': 'Nom',
    'portal.field.contactEmail': 'E-mail',
    'portal.field.contactPhone': 'Téléphone',
    'portal.lead.back': 'Tous les leads',
    'portal.lead.submitted': 'Inscrit le {date} par {name}',
    'portal.lead.signedOn': 'Contrat signé le {date}',
    'portal.lead.relationship': 'Relation client',
    'portal.lead.since': 'Client depuis {since}',
    'portal.lead.contact': 'Contact',
    'portal.lead.refused': 'Wally a refusé cette inscription.',
    'portal.lead.reason': 'Raison : {reason}',
    'portal.lead.reason.ask': 'Demander la raison',
    'portal.lead.reason.asked': 'Vous avez demandé la raison le {date}. Wally vous répondra.',
    'portal.lead.evidence.title': 'Wally demande des justificatifs',
    'portal.lead.evidence.answer': 'Votre réponse',
    'portal.lead.evidence.send': 'Envoyer',
    'portal.lead.evidence.answered': 'Répondu le {date}',
    'portal.lead.edit': 'Modifier',
    'portal.lead.save': 'Enregistrer',
    'portal.lead.cancel': 'Annuler',
    'portal.lead.withdraw': 'Retirer l’inscription',
    'portal.lead.withdraw.confirm': 'Retirer cette inscription ? Elle ne pourra plus donner droit à une commission.',
    'portal.dashboard.commission': 'Vos commissions',
    'portal.dashboard.commission.thisMonth': 'Ce mois-ci',
    'portal.dashboard.commission.lastMonth': 'Le mois dernier',
    'portal.dashboard.commission.thisYear': 'Cette année',
    'portal.dashboard.commission.toDate': 'Depuis le début',
    'portal.dashboard.commission.note': 'Commission sur les montants hors TVA encaissés par Wally auprès de vos leads, comptée au mois de l’encaissement.',
    'portal.leads.col.lastPayment': 'Dernier paiement',
    'portal.leads.col.commission': 'Commission',
    'portal.lead.lastPayment': 'Dernier paiement le {date}',
    'portal.lead.licences': 'Licences',
    'portal.lead.licence.seats': '{n} utilisateurs',
    'portal.lead.licence.dossiers': '{n} dossiers',
    'portal.lead.interval.month': 'mois',
    'portal.lead.interval.year': 'an',
    'portal.lead.commission': 'Paiements et commission',
    'portal.lead.commission.total': 'Commission à ce jour : {amount}',
    'portal.lead.commission.none': 'Wally n’a encore reçu aucun paiement de ce lead.',
    'portal.lead.commission.col.date': 'Date',
    'portal.lead.commission.col.kind': 'Type',
    'portal.lead.commission.col.invoice': 'Facture Wally',
    'portal.lead.commission.col.base': 'Montant HTVA',
    'portal.lead.commission.col.commission': 'Commission',
    'portal.lead.kind.payment': 'Paiement',
    'portal.lead.kind.credit_note': 'Note de crédit',
    'portal.lead.kind.refund': 'Remboursement',
    'portal.lead.kind.dispute_lost': 'Paiement contesté',
    'portal.lead.kind.adjustment': 'Correction',
    'portal.dashboard.lastStatement': 'Dernier décompte : {month}, {amount} ({status})',
    'portal.statements.title': 'Décomptes',
    'portal.statements.empty': 'Aucun décompte publié pour l’instant. Wally publie un décompte après chaque mois où vos leads ont payé.',
    'portal.statements.col.month': 'Mois',
    'portal.statements.col.number': 'Référence',
    'portal.statements.col.commission': 'Commission HTVA',
    'portal.statements.col.status': 'Statut',
    'portal.statements.col.due': 'Échéance',
    'portal.statement.status.published': 'À facturer',
    'portal.statement.status.invoiced': 'Facturé',
    'portal.statement.status.paid': 'Payé',
    'portal.statement.back': 'Tous les décomptes',
    'portal.statement.title': 'Décompte {month}',
    'portal.statement.published': 'Publié le {date}',
    'portal.statement.invoiced': 'Votre facture {number} du {date}',
    'portal.statement.paid': 'Payé le {date}',
    'portal.statement.due': 'Échéance : {date}',
    'portal.statement.pdf': 'Télécharger le PDF',
    'portal.statement.invoiceHint': 'Envoyez à Wally une facture de {amount} hors TVA via Peppol, avec la référence {number}. Wally paie dans les 30 jours après la fin du mois (art. 3.4).',
    'portal.statement.col.lead': 'Lead',
    'portal.statement.col.date': 'Date',
    'portal.statement.col.kind': 'Type',
    'portal.statement.col.invoice': 'Facture Wally',
    'portal.statement.col.base': 'Montant HTVA',
    'portal.statement.col.commission': 'Commission',
    'portal.statement.total': 'Total',
    'portal.statement.partnerWide': 'Ensemble du partenariat',
    'portal.lead.kind.correction': 'Correction',
    'pdf.statement.title': 'Décompte de commissions',
    'pdf.statement.number': 'Référence',
    'pdf.statement.period': 'Période',
    'pdf.statement.issued': 'Publié le',
    'pdf.statement.from': 'Émis par',
    'pdf.statement.to': 'Partenaire',
    'pdf.statement.companyNumber': 'N° d’entreprise {number}',
    'pdf.statement.convention': 'Convention de partenariat « {name} » signée le {date}, article 3.4.',
    'pdf.statement.totalBase': 'Total encaissé par Wally, hors TVA',
    'pdf.statement.totalCommission': 'Commission due, hors TVA',
    'pdf.statement.vat': 'Montants hors TVA. Le partenaire ajoute la TVA sur sa facture.',
    'pdf.statement.due': 'Échéance de paiement : {date}',
    'pdf.statement.page': 'Page {n} / {total}',
    'email.statement.subject': 'Votre décompte de commissions pour {month}',
    'email.statement.body': 'Wally a publié votre décompte pour {month} : {amount} de commission hors TVA. Vous pouvez le consulter et télécharger le PDF dans le portail partenaire, puis envoyer votre facture via Peppol avec la référence {number}.',
    'email.statement.button': 'Voir le décompte',
    'portal.lead.stage.title': 'Où en est ce lead ?',
    'portal.lead.stage.hint': 'Vous menez la vente vous-même : indiquez ici où en est ce lead. Wally le voit aussi.',
    'portal.lead.stage.label': 'Statut',
    'portal.lead.stage.signedOn': 'Contrat signé le',
    'portal.lead.stage.save': 'Enregistrer',
    'portal.lead.stage.updated': 'Mis à jour le {date} par {name}',
    'portal.status.submitted': 'Inscrit',
    'portal.status.evidence_requested': 'Justificatifs demandés',
    'portal.status.refused': 'Refusé',
    'portal.status.withdrawn': 'Retiré',
    'portal.status.in_progress': 'Validé',
    'portal.status.demo_planned': 'Démo planifiée',
    'portal.status.demo_done': 'Démo effectuée',
    'portal.status.customer': 'Client Wally',
    'portal.status.lost': 'Perdu',
    'portal.comingSoon': 'Bientôt disponible',
    'portal.comingSoon.body': 'Cette page arrive dans une prochaine version du portail.',
    'portal.error.generic': 'Une erreur s’est produite. Réessayez.',
    'portal.error.tooMany': 'Trop de tentatives. Réessayez dans quelques minutes.',
    'email.login.subject': 'Votre lien de connexion au portail partenaire Wally',
    'email.login.greeting': 'Bonjour {name},',
    'email.login.intro': 'Voici votre lien pour vous connecter au portail partenaire Wally :',
    'email.login.button': 'Se connecter',
    'email.login.expires': 'Ce lien est valable 15 minutes et ne peut être utilisé qu’une seule fois. Vous n’avez rien demandé ? Ignorez simplement cet e-mail.',
    'email.invite.subject': 'Votre accès au portail partenaire Wally',
    'email.invite.intro': '{inviter} de Wally vous a donné accès au portail partenaire de {partner}. Vous y inscrivez vos clients existants comme leads et suivez vos commissions.',
    'email.decision.subject.accepted': 'Inscription validée : {lead}',
    'email.decision.subject.refused': 'Inscription refusée : {lead}',
    'email.decision.subject.evidence': 'Justificatifs demandés : {lead}',
    'email.decision.subject.reason': 'Raison du refus : {lead}',
    'email.decision.body.accepted': 'Wally a validé l’inscription de {lead}. Vous pouvez suivre son statut dans le portail partenaire.',
    'email.decision.body.refused': 'Wally a refusé l’inscription de {lead}. Vous pouvez en demander la raison dans le portail partenaire.',
    'email.decision.body.reason': 'Voici la raison pour laquelle Wally a refusé l’inscription de {lead} :',
    'email.decision.body.evidence': 'Wally vous demande des justificatifs pour l’inscription de {lead}. Vous pouvez répondre directement dans le portail partenaire.',
    'email.decision.button': 'Ouvrir le portail',
    'email.footer.brand': 'Wally · agent.wally BV',
};
const portalNl = {
    'portal.brand': 'Wally Partners',
    'portal.language': 'Taal',
    'portal.signOut': 'Afmelden',
    'portal.login.title': 'Aanmelden bij het partnerportaal',
    'portal.login.body': 'Vul je zakelijke e-mailadres in. We sturen je een link om aan te melden.',
    'portal.login.email': 'E-mailadres',
    'portal.login.submit': 'Stuur me een aanmeldlink',
    'portal.login.sent.title': 'Kijk in je mailbox',
    'portal.login.sent.body': 'Als {email} toegang heeft tot het portaal, krijg je zo meteen een aanmeldlink. De link is 15 minuten geldig.',
    'portal.login.again': 'Een ander adres gebruiken',
    'portal.verify.title': 'Aanmelden',
    'portal.verify.body': 'Klik op de knop om aan te melden bij het partnerportaal.',
    'portal.verify.submit': 'Aanmelden',
    'portal.verify.invalid': 'Deze link werkt niet meer. Misschien is hij al gebruikt of verlopen. Vraag een nieuwe aan.',
    'portal.nav.dashboard': 'Dashboard',
    'portal.nav.leads': 'Leads',
    'portal.nav.register': 'Lead inschrijven',
    'portal.nav.statements': 'Afrekeningen',
    'portal.dashboard.welcome': 'Dag {name}',
    'portal.dashboard.intro': 'Volg hier de leads die je hebt ingeschreven, hun status en je commissies.',
    'portal.dashboard.total': '{count} ingeschreven leads',
    'portal.dashboard.register': 'Een nieuwe lead inschrijven',
    'portal.leads.title': 'Je leads',
    'portal.leads.empty': 'Je hebt nog geen leads ingeschreven.',
    'portal.leads.col.name': 'Lead',
    'portal.leads.col.number': 'Ondernemingsnummer',
    'portal.leads.col.status': 'Status',
    'portal.leads.col.submitted': 'Ingeschreven op',
    'portal.leads.col.signed': 'Contract getekend op',
    'portal.register.title': 'Lead inschrijven',
    'portal.register.rules': 'Een lead is een van je bestaande klanten: een kantoor waarmee je al een effectieve klantrelatie hebt. Gewone prospects kun je niet inschrijven. Wally controleert elke inschrijving; de eerste geldige inschrijving van een ondernemingsnummer heeft voorrang.',
    'portal.register.submit': 'Inschrijven',
    'portal.register.duplicate': 'Je hebt deze klant al ingeschreven.',
    'portal.register.entityChanged': 'De entiteit is in een ander tabblad gewijzigd. Controleer de gekozen entiteit en schrijf opnieuw in.',
    'portal.field.legalName': 'Exacte juridische naam',
    'portal.field.country': 'Land',
    'portal.field.companyNumber': 'Ondernemingsnummer',
    'portal.field.companyNumber.invalid': 'Dit nummer is niet geldig.',
    'portal.field.vatNumber.optional': 'Btw-nummer (optioneel)',
    'portal.field.rcs': 'RCS-nummer (optioneel)',
    'portal.field.rcs.hint': 'Bijvoorbeeld: B123456',
    'portal.field.rcs.invalid': 'Dit RCS-nummer is niet geldig (een letter en dan cijfers, bijvoorbeeld B123456).',
    'portal.field.entity': 'Voor welke entiteit?',
    'portal.field.entity.hint': 'De entiteit die de commissie op deze klant ontvangt.',
    'portal.field.entity.required': 'Kies de entiteit.',
    'portal.entity.switch': 'Andere entiteit',
    'portal.field.since': 'Klant sinds',
    'portal.field.since.hint': 'Bijvoorbeeld: 2019',
    'portal.field.description': 'Je relatie met deze klant',
    'portal.field.description.hint': 'Wat je aan dit kantoor levert (software, diensten), zodat Wally de relatie kan nagaan.',
    'portal.field.contact': 'Contactpersoon bij het kantoor (optioneel)',
    'portal.field.contactName': 'Naam',
    'portal.field.contactEmail': 'E-mail',
    'portal.field.contactPhone': 'Telefoon',
    'portal.lead.back': 'Alle leads',
    'portal.lead.submitted': 'Ingeschreven op {date} door {name}',
    'portal.lead.signedOn': 'Contract getekend op {date}',
    'portal.lead.relationship': 'Klantrelatie',
    'portal.lead.since': 'Klant sinds {since}',
    'portal.lead.contact': 'Contact',
    'portal.lead.refused': 'Wally heeft deze inschrijving geweigerd.',
    'portal.lead.reason': 'Reden: {reason}',
    'portal.lead.reason.ask': 'Reden vragen',
    'portal.lead.reason.asked': 'Je vroeg de reden op {date}. Wally laat het je weten.',
    'portal.lead.evidence.title': 'Wally vraagt bewijs',
    'portal.lead.evidence.answer': 'Je antwoord',
    'portal.lead.evidence.send': 'Versturen',
    'portal.lead.evidence.answered': 'Beantwoord op {date}',
    'portal.lead.edit': 'Wijzigen',
    'portal.lead.save': 'Opslaan',
    'portal.lead.cancel': 'Annuleren',
    'portal.lead.withdraw': 'Inschrijving intrekken',
    'portal.lead.withdraw.confirm': 'Deze inschrijving intrekken? Ze kan dan geen recht op commissie meer geven.',
    'portal.dashboard.commission': 'Je commissies',
    'portal.dashboard.commission.thisMonth': 'Deze maand',
    'portal.dashboard.commission.lastMonth': 'Vorige maand',
    'portal.dashboard.commission.thisYear': 'Dit jaar',
    'portal.dashboard.commission.toDate': 'Sinds de start',
    'portal.dashboard.commission.note': 'Commissie op de bedragen excl. btw die Wally van je leads ontving, geteld in de maand van ontvangst.',
    'portal.leads.col.lastPayment': 'Laatste betaling',
    'portal.leads.col.commission': 'Commissie',
    'portal.lead.lastPayment': 'Laatste betaling op {date}',
    'portal.lead.licences': 'Licenties',
    'portal.lead.licence.seats': '{n} gebruikers',
    'portal.lead.licence.dossiers': '{n} dossiers',
    'portal.lead.interval.month': 'maand',
    'portal.lead.interval.year': 'jaar',
    'portal.lead.commission': 'Betalingen en commissie',
    'portal.lead.commission.total': 'Commissie tot nu: {amount}',
    'portal.lead.commission.none': 'Wally ontving nog geen betaling van deze lead.',
    'portal.lead.commission.col.date': 'Datum',
    'portal.lead.commission.col.kind': 'Soort',
    'portal.lead.commission.col.invoice': 'Wally-factuur',
    'portal.lead.commission.col.base': 'Bedrag excl. btw',
    'portal.lead.commission.col.commission': 'Commissie',
    'portal.lead.kind.payment': 'Betaling',
    'portal.lead.kind.credit_note': 'Creditnota',
    'portal.lead.kind.refund': 'Terugbetaling',
    'portal.lead.kind.dispute_lost': 'Betwiste betaling',
    'portal.lead.kind.adjustment': 'Correctie',
    'portal.dashboard.lastStatement': 'Laatste afrekening: {month}, {amount} ({status})',
    'portal.statements.title': 'Afrekeningen',
    'portal.statements.empty': 'Nog geen afrekeningen gepubliceerd. Wally publiceert een afrekening na elke maand waarin je leads betaalden.',
    'portal.statements.col.month': 'Maand',
    'portal.statements.col.number': 'Referentie',
    'portal.statements.col.commission': 'Commissie excl. btw',
    'portal.statements.col.status': 'Status',
    'portal.statements.col.due': 'Vervaldag',
    'portal.statement.status.published': 'Te factureren',
    'portal.statement.status.invoiced': 'Gefactureerd',
    'portal.statement.status.paid': 'Betaald',
    'portal.statement.back': 'Alle afrekeningen',
    'portal.statement.title': 'Afrekening {month}',
    'portal.statement.published': 'Gepubliceerd op {date}',
    'portal.statement.invoiced': 'Je factuur {number} van {date}',
    'portal.statement.paid': 'Betaald op {date}',
    'portal.statement.due': 'Vervaldag: {date}',
    'portal.statement.pdf': 'PDF downloaden',
    'portal.statement.invoiceHint': 'Stuur Wally via Peppol een factuur van {amount} excl. btw met referentie {number}. Wally betaalt binnen 30 dagen na het einde van de maand (art. 3.4).',
    'portal.statement.col.lead': 'Lead',
    'portal.statement.col.date': 'Datum',
    'portal.statement.col.kind': 'Soort',
    'portal.statement.col.invoice': 'Wally-factuur',
    'portal.statement.col.base': 'Bedrag excl. btw',
    'portal.statement.col.commission': 'Commissie',
    'portal.statement.total': 'Totaal',
    'portal.statement.partnerWide': 'Hele partnerschap',
    'portal.lead.kind.correction': 'Correctie',
    'pdf.statement.title': 'Commissie-afrekening',
    'pdf.statement.number': 'Referentie',
    'pdf.statement.period': 'Periode',
    'pdf.statement.issued': 'Gepubliceerd op',
    'pdf.statement.from': 'Uitgegeven door',
    'pdf.statement.to': 'Partner',
    'pdf.statement.companyNumber': 'Ondernemingsnummer {number}',
    'pdf.statement.convention': 'Partnerovereenkomst "{name}", getekend op {date}, artikel 3.4.',
    'pdf.statement.totalBase': 'Totaal ontvangen door Wally, excl. btw',
    'pdf.statement.totalCommission': 'Verschuldigde commissie, excl. btw',
    'pdf.statement.vat': 'Bedragen excl. btw. De partner rekent de btw aan op zijn factuur.',
    'pdf.statement.due': 'Vervaldag van de betaling: {date}',
    'pdf.statement.page': 'Pagina {n} / {total}',
    'email.statement.subject': 'Je commissie-afrekening van {month}',
    'email.statement.body': 'Wally publiceerde je afrekening van {month}: {amount} commissie excl. btw. Je bekijkt ze en downloadt de PDF in het partnerportaal; stuur daarna je factuur via Peppol met referentie {number}.',
    'email.statement.button': 'Afrekening bekijken',
    'portal.lead.stage.title': 'Waar staat deze lead?',
    'portal.lead.stage.hint': 'Je doet de verkoop zelf: duid hier aan waar deze lead staat. Wally ziet het ook.',
    'portal.lead.stage.label': 'Status',
    'portal.lead.stage.signedOn': 'Contract getekend op',
    'portal.lead.stage.save': 'Opslaan',
    'portal.lead.stage.updated': 'Bijgewerkt op {date} door {name}',
    'portal.status.submitted': 'Ingeschreven',
    'portal.status.evidence_requested': 'Bewijs gevraagd',
    'portal.status.refused': 'Geweigerd',
    'portal.status.withdrawn': 'Ingetrokken',
    'portal.status.in_progress': 'Aanvaard',
    'portal.status.demo_planned': 'Demo ingepland',
    'portal.status.demo_done': 'Demo gehad',
    'portal.status.customer': 'Klant bij Wally',
    'portal.status.lost': 'Verloren',
    'portal.comingSoon': 'Binnenkort beschikbaar',
    'portal.comingSoon.body': 'Deze pagina komt in een volgende versie van het portaal.',
    'portal.error.generic': 'Er ging iets mis. Probeer opnieuw.',
    'portal.error.tooMany': 'Te veel pogingen. Probeer het over enkele minuten opnieuw.',
    'email.login.subject': 'Je aanmeldlink voor het Wally-partnerportaal',
    'email.login.greeting': 'Dag {name},',
    'email.login.intro': 'Hier is je link om aan te melden bij het Wally-partnerportaal:',
    'email.login.button': 'Aanmelden',
    'email.login.expires': 'Deze link is 15 minuten geldig en werkt maar één keer. Niets gevraagd? Dan mag je deze e-mail negeren.',
    'email.invite.subject': 'Je toegang tot het Wally-partnerportaal',
    'email.invite.intro': '{inviter} van Wally heeft je toegang gegeven tot het partnerportaal van {partner}. Daar schrijf je je bestaande klanten in als lead en volg je je commissies op.',
    'email.decision.subject.accepted': 'Inschrijving aanvaard: {lead}',
    'email.decision.subject.refused': 'Inschrijving geweigerd: {lead}',
    'email.decision.subject.evidence': 'Bewijs gevraagd: {lead}',
    'email.decision.subject.reason': 'Reden van weigering: {lead}',
    'email.decision.body.accepted': 'Wally heeft de inschrijving van {lead} aanvaard. Je volgt de status op in het partnerportaal.',
    'email.decision.body.refused': 'Wally heeft de inschrijving van {lead} geweigerd. Je kunt de reden vragen in het partnerportaal.',
    'email.decision.body.reason': 'Dit is de reden waarom Wally de inschrijving van {lead} weigerde:',
    'email.decision.body.evidence': 'Wally vraagt bewijs voor de inschrijving van {lead}. Je kunt rechtstreeks in het partnerportaal antwoorden.',
    'email.decision.button': 'Portaal openen',
    'email.footer.brand': 'Wally · agent.wally BV',
};
const ui = { fr: uiFr, nl: uiNl, en: uiEn };
const portal = { fr: portalFr, nl: portalNl };
function fill(template, vars) {
    return template.replace(/\{(\w+)\}/g, (m, name) => vars[name] ?? m);
}
/** A shared component string. */
export function t(locale, key, vars = {}) {
    return fill(ui[locale][key], vars);
}
/** A portal or partner email string. */
export function tp(locale, key, vars = {}) {
    return fill(portal[locale][key], vars);
}
/** For the parity spec. */
export const CATALOGUES = { ui, portal };
const DATE_LOCALES = { fr: 'fr-BE', nl: 'nl-BE', en: 'en-GB' };
/** "26 octobre 2026" / "26 oktober 2026", in Brussels time. */
export function formatDate(locale, date) {
    return new Intl.DateTimeFormat(DATE_LOCALES[locale], {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        timeZone: 'Europe/Brussels',
    }).format(date);
}
/** "novembre 2026" / "november 2026" for `YYYY-MM`. */
export function formatMonth(locale, month) {
    const [y, m] = month.split('-').map(Number);
    return new Intl.DateTimeFormat(DATE_LOCALES[locale], {
        month: 'long',
        year: 'numeric',
        timeZone: 'UTC',
    }).format(new Date(Date.UTC(y, m - 1, 15)));
}
/** "3 750,00 €" from integer cents. */
export function formatMoney(locale, cents, currency = 'EUR') {
    return new Intl.NumberFormat(DATE_LOCALES[locale], { style: 'currency', currency }).format(cents / 100);
}
